/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Pause_DurationInputs */

const en_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause Duration (ms)`)
};

const fr_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de la pause (ms)`)
};

const de_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausendauer (ms)`)
};

const it_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata della pausa (ms)`)
};

const ru_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длительность паузы (мс)`)
};

const es_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración de la pausa (ms)`)
};

const zh_cn2_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂停时长（毫秒）`)
};

const ja_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一時停止時間（ミリ秒）`)
};

const hi_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विराम अवधि (मिलीसेकंड)`)
};

const pt_pt2_options_editor_pause_duration = /** @type {(inputs: Options_Editor_Pause_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração da pausa (ms)`)
};

/**
* | output |
* | --- |
* | "Pause Duration (ms)" |
*
* @param {Options_Editor_Pause_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_pause_duration = /** @type {((inputs?: Options_Editor_Pause_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Pause_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_pause_duration(inputs)
	if (locale === "de") return de_options_editor_pause_duration(inputs)
	if (locale === "it") return it_options_editor_pause_duration(inputs)
	if (locale === "ru") return ru_options_editor_pause_duration(inputs)
	if (locale === "es") return es_options_editor_pause_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_pause_duration(inputs)
	if (locale === "ja") return ja_options_editor_pause_duration(inputs)
	if (locale === "hi") return hi_options_editor_pause_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_pause_duration(inputs)
	return en_options_editor_pause_duration(inputs)
});